import React, { memo, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Controller } from 'react-hook-form';
import DropDown, { DropDownItem } from '../DropDown';
import { EvaluationFieldProps } from '../../types/Evaluation';
import Box from '@material-ui/core/Box/Box';

const useStyles = makeStyles(theme => ({
  fieldLabel: {
      width: 160,
      fontSize: theme.typography.pxToRem(16),
      color: theme.palette.text.primary,
      fontWeight: 600,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        marginBottom: theme.spacing(0.5),
      },
    },
}), { name: 'SingleSelectInput' });

function SingleSelectInput({ name, control, label, selectionMessage = 'Select...', options = [] }: EvaluationFieldProps) {
  const classes = useStyles();
  const items: DropDownItem[] = useMemo(
    () => options.map(opt => ({ value: opt, content: opt })),
    [options],
  );

  const emptyItem: DropDownItem = useMemo(
    () => ({ value: '', content: selectionMessage }),
    [selectionMessage],
  );

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value, onBlur } }) => (
        <>
            <Box className={classes.fieldLabel}>{label}:</Box>
            <DropDown
            items={items}
            value={value || ''}
            emptyItem={emptyItem}
            onChange={onChange}
            onBlur={onBlur}
            />
        </>
      )}
    />
  );
}

export default memo(SingleSelectInput);
